function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragi = function SvgDragi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 6 12",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M1 2a1 1 0 1 0 0-2 1 1 0 1 0 0 2m0 5a1 1 0 1 0 0-2 1 1 0 1 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 1 1 2 0m3-9a1 1 0 1 0 0-2 1 1 0 1 0 0 2m1 4a1 1 0 1 1-2 0 1 1 0 1 1 2 0m-1 6a1 1 0 1 0 0-2 1 1 0 1 0 0 2"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragi);
export default ForwardRef;